import { render } from "./App.vue?vue&type=template&id=7a5a02d0&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=7a5a02d0&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__